import React, { useCallback, useMemo } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router';
import { useTranslation } from 'react-i18next';
import Record, { RecordSaveState } from '../components/record/record.component';
import { useFormSettingsQuery } from '../redux/services/api';

function SimpleRecordView() {
  const { formId, recordId } = useParams();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { search } = useLocation();

  const searchParams = useMemo(() => new URLSearchParams(search), [search]);
  const hideSections = useMemo(() => searchParams.get('hideSections') === 'true', [searchParams]);

  const { data: formSettingsData } = useFormSettingsQuery(parseInt(formId ?? ''), {
    skip: formId === undefined || isNaN(parseInt(formId)),
  });

  const onRecordCreated = useCallback(
    (id: string) => {
      if (!recordId) {
        const path = hideSections ? `${id}?hideSections=true` : id;
        navigate(path, { replace: true });
      }
    },
    [hideSections, recordId, navigate]
  );

  const recordState = useMemo(() => (recordId ? RecordSaveState.Update : RecordSaveState.New), [recordId]);

  const recordTitle = useMemo(() => {
    return recordState === RecordSaveState.New
      ? t('form-new-record', { formName: formSettingsData?.caption })
      : undefined;
  }, [recordState, formSettingsData?.caption, t]);

  const canRenderRecord = formId && isFinite(parseInt(formId)) && formSettingsData;

  return (
    <div className="h-full w-full bg-gray-5 p-4">
      <div className="m-auto flex h-full max-w-screen-lg flex-col overflow-y-auto">
        {canRenderRecord && (
          <Record
            formId={parseInt(formId)}
            recordId={recordId}
            recordState={recordState}
            title={recordTitle}
            onClose={() => {}}
            showFormGroupsNavigation={!hideSections}
            onSimpleViewRecordCreated={onRecordCreated}
            isSimpleView
          />
        )}
      </div>
    </div>
  );
}

export default React.memo(SimpleRecordView);
